import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  Input,
  useInputField,
  ValidationIcon,
} from '@edreamsodigeo/prisma-design-system';
import { FormFieldWrapper } from './FormFieldWrapper';

export const FormInput = ({
  id,
  label,
  value,
  type = 'text',
  onBlur,
  validate,
  disabled,
  showErrors,
}) => {
  const [wasFocused, setWasFocused] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const { inputProps, iconProps, labelProps, fieldProps, validationProps } =
    useInputField({
      value: inputValue,
      onClick: () => setWasFocused(true),
      onChange: (event) => {
        setInputValue(event.currentTarget.value);
      },
      onReset: () => setInputValue(''),
      disabled,
      type,
      id,
      validate: (value) => {
        if (validate(value)) return true;
        if (showErrors) return false;
        return !wasFocused;
      },
    });

  const onBlurProp = inputProps.onBlur;
  inputProps.onBlur = () => {
    onBlurProp();
    onBlur(inputValue);
  };

  return (
    <FormFieldWrapper
      label={label}
      fieldProps={fieldProps}
      labelProps={labelProps}
      validationProps={validationProps}
    >
      <Flex wrap="nowrap" flex={1}>
        <Input data-testid={`form-field-${id}`} {...inputProps} />
        <ValidationIcon {...iconProps} />
      </Flex>
    </FormFieldWrapper>
  );
};

FormInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  onBlur: PropTypes.func,
  validate: PropTypes.func,
  disabled: PropTypes.bool,
  showErrors: PropTypes.bool,
};

FormInput.defaultProps = {
  value: '',
  type: 'text',
  onBlur: () => {},
  validate: () => true,
  disabled: false,
  showErrors: false,
};
